import * as React from "react";
import { Route, Switch, useHistory, useParams } from "react-router";
import { ClinicLink } from "./clinicLink";
import { InvitationsTable } from "./invitaionsTable";
import { InviteMethodsMenu } from "./InviteMethodsMenu";
import { ClinicPageWrapper } from "../../elements/clinicPageWrapper";
import { useState } from "react";
import { Button, Menu, MenuItem, styled } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useClinicState } from "../../../../clinic/clinicStateContext";
import { InvitePersonalLink } from "./invitePersonalLink";
import { ReactComponent as CopyLinkIcon } from "../../../../assets/clinic/copyLinkIcon.svg";
import { ReactComponent as PersonalLinkIcon } from "../../../../assets/clinic/personlaLinkIcon.svg";
import { ReactComponent as EmailIcon } from "../../../../assets/clinic/emailIcon.svg";
import { CLINIC_MANAGE_URL } from "../../clinicSettings/clinicUrls";

//region [[ Styles ]]
const ViaButton = styled(Button)({
  textTransform: "none",
  padding: "2px 4px",
  marginLeft: 8,
  marginBottom: -6,
  "& span": { lineHeight: 1 },
  "& svg": { width: 24, height: 24, marginBottom: 4 },
});
const ViaMenuItem = styled(MenuItem)({
  gap: 10,
  "& svg": { width: 24, height: 24 },
});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface InviteRouterProps {}

export enum InviteMethods {
  "Generic" = "generic",
  "Personal" = "personal",
  "List" = "list",
}

const methodNames = {
  [InviteMethods.Generic]: "Generic Link",
  [InviteMethods.Personal]: "Personal Link",
  [InviteMethods.List]: "Email/SMS",
};

const methodIcons = {
  [InviteMethods.Generic]: <CopyLinkIcon />,
  [InviteMethods.Personal]: <PersonalLinkIcon />,
  [InviteMethods.List]: <EmailIcon />,
};

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const InviteRouter = ({ ...props }: InviteRouterProps) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const [
    {
      clinicData: { id: clinicId },
    },
  ] = useClinicState();

  const history = useHistory();

  const handleSelect = (method: InviteMethods) => {
    history.push(`${CLINIC_MANAGE_URL}/${clinicId}/invite/${method}`);
    handleClose();
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const { method } : {method: string }= useParams();
  return (
    <ClinicPageWrapper
      pageTitle={
        <>
          Invite Patients
          {method && (
            <>
              <ViaButton
                variant={"text"}
                onClick={handleClick}
                endIcon={<ExpandMoreIcon />}
                startIcon={methodIcons[method]}
              >
                Via {methodNames[method]}
              </ViaButton>
              <Menu
                id="methods-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                {Object.values(InviteMethods).map((m) => (
                  <ViaMenuItem key={m + "Link"} onClick={() => handleSelect(m)}>
                    {methodIcons[m]}
                    {methodNames[m]}
                  </ViaMenuItem>
                ))}
              </Menu>
            </>
          )}
        </>
      }
    >
      <Switch>
        <Route path={`*/${InviteMethods.Generic}`} component={ClinicLink} />
        <Route
          path={`*/${InviteMethods.Personal}`}
          component={InvitePersonalLink}
        />
        <Route path={`*/${InviteMethods.List}`} component={InvitationsTable} />
        <Route render={() => <InviteMethodsMenu onSelect={handleSelect} />} />
      </Switch>
    </ClinicPageWrapper>
  );
};
